/* eslint react/no-multi-comp: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';

import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import ianHeadshotSmile from '../../images/characters/ian_headshot_smile.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';
import ianSaraLeanSmile from '../../images/characters/ian_sara_lean_smile.png';
import ianSide from '../../images/characters/ian_side.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import saraTwistHandsOutHeyhey from '../../images/characters/sara_twist_hands_out_heyhey.png';
import ianPointingUp from '../../images/characters/ian_pointing_up.png';
import ianPointingLeft from '../../images/characters/ian_pointing_left.png';
import ianPointingDown from '../../images/characters/ian_pointing_down.png';
import saraSmile from '../../images/characters/sara_smile.png';
import saraHumph from '../../images/characters/sara_humph.png';
import ianSaraLeanQuestioning from '../../images/characters/ian_sara_lean_questioning.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_floorplan.md';
import markdownFileLevel2 from './level2_kitRap.md';
import markdownFileLevel3 from './level3_drawing.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) }
};

export function preloadClassActivity () {
  preloader([
    ianHeadshotSmile,
    ianSaraSide,
    ianSaraLeanSmile,
    ianSide,
    saraSurprised,
    saraTwistHandsOutHeyhey,
    ianPointingUp,
    ianPointingLeft,
    ianPointingDown,
    saraSmile,
    saraHumph,
    ianSaraLeanQuestioning
  ]);
}

function introVideo (level, regionData) {
  const md = levels[level].md;
  return (
    videoSlide({
      id: 'intro-video',
      notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
      youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
    })
  );
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'sizzle',
      characterSide: 'right',
      characterImage: ianSaraSide,
      notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Sizzle', 'Content', false, regionData)
    })
  );
}

function instructions (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'instructions',
      characterSide: 'right',
      characterImage: ianSaraLeanSmile,
      notes: md.getSubSectionAsHtml('Instructions', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Instructions', 'Content', false, regionData)
    })
  );
}

function scoring (level, regionData) {
  const md = levels[level].md;
  return (
    balloonSlide({
      id: 'scoring',
      characterSide: 'left',
      characterImage: ianSide,
      notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
      html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData)
    })
  );
}

function level1 (regionData) { // floorplan
  const level = '1';
  return (

    <Section id={`class-activity-${level}`}>
      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function level2 (regionData) { // Draw Energy
  const level = '2';
  const md = levels[level].md;
  return (

    <Section id={`class-activity-${level}`}>

      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

      {/* Rap Backtrack Practice */}
      {videoSlide({
        id: 'rap-backtrack-practice',
        notes: md.getSubSectionAsHtml('Rap Backtrack Practice', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Rap Backtrack Practice', 'YouTube', regionData)
      })}

      {/* Scoring */}
      {scoring(level, regionData)}

      {/* Rap Backtrack Perform */}
      {videoSlide({
        id: 'rap-backtrack-perform',
        notes: md.getSubSectionAsHtml('Rap Backtrack Perform', 'Notes', false, regionData),
        youTubeId: md.getSectionMetadata('Rap Backtrack Perform', 'YouTube', regionData)
      })}

    </Section>
  );
}

function level3 (regionData) { // Energy saving rap
  const level = '3';
  return (

    <Section id={`class-activity-${level}`}>
      {/* Intro Video */}
      {introVideo(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Instructions */}
      {instructions(level, regionData)}

    </Section>
  );
}

function classActivitySection ({ level, subActivity, regionData }) {
  switch (`${level}${subActivity ? subActivity : ''}`) {
  case '1':
    return level1(regionData);
  case '2':
    return level2(regionData);
  case '3':
    return level3(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default classActivitySection;



// WEBPACK FOOTER //
// ./programs/epsHybridPrimaries/sections/30_classActivity/classActivitySection.jsx